export default __webpack_public_path__ + "static/media/3058.74066968.jpg";